<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img id="profile-img" src="../assets/ggpoker.png" />
      <Form v-if="!message" @submit="handleSendMoney" :validation-schema="schema">
        <div>
          <div class="form-group">
            <label for="cpf">CPF</label>
            <Field
              name="cpf"
              type="text"
              class="form-control"
              v-model="fields.cpf"
            />
            <ErrorMessage name="cpf" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="typePix">Tipo PIX</label>
            <!-- <Field name="typePix" type="text" class="form-control" /> -->
            <Field
              name="typePix"
              as="select"
              class="form-control"
              v-model="fields.typePix"
            >
              <option>CPF</option>
              <option>Fone</option>
              <option>E-Mail</option>
              <option>Chave Aleatória</option>
            </Field>
            <ErrorMessage name="typePix" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="chavePix">Chave PIX</label>
            <Field
              name="chavePix"
              type="text"
              class="form-control"
              v-model="fields.chavePix"
            />
            <ErrorMessage name="chavePix" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="value">Valor</label>
            <Field
              name="value"
              type="number"
              class="form-control"
              v-model="fields.value"
            />
            <ErrorMessage name="value" class="error-feedback" />
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block" :disabled="loading">
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              Enviar
            </button>
          </div>
        </div>
      </Form>
      <div v-if="successful">
        <button
          class="btn btn-primary btn-block"
          :disabled="loading"
          @click="newTransaction()"
        >
          <span
            v-show="loading"
            class="spinner-border spinner-border-sm"
          ></span>
          Nova transação
        </button>
        <button
          class="btn btn-primary btn-block"
          :disabled="loading"
          @click="comprovante()"
        >
          <span
            v-show="loading"
            class="spinner-border spinner-border-sm"
          ></span>
          Comprovante
        </button>
      </div>
      <div
        v-if="message"
        class="alert"
        :class="successful ? 'alert-success' : 'alert-danger'"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>
  
  <script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "SendMoney",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      username: yup
        .string()
        .required("Username is required!")
        .min(3, "Must be at least 3 characters!")
        .max(20, "Must be maximum 20 characters!"),
      email: yup
        .string()
        .required("Email is required!")
        .email("Email is invalid!")
        .max(50, "Must be maximum 50 characters!"),
      password: yup
        .string()
        .required("Password is required!")
        .min(6, "Must be at least 6 characters!")
        .max(40, "Must be maximum 40 characters!"),
    });

    return {
      idWithdraw: "",
      successful: false,
      loading: false,
      message: "",
      schema,
      fields: {
        cpf: "",
        typePix: "",
        chavePix: "",
        value: "",
      },
    };
  },
  computed: {
    loggedIn() {
      return (
        this.$store.state.auth.status.loggedIn &&
        this.$store.state.auth.user.validOTP
      );
    },
  },
  mounted() {
    if (!this.loggedIn) {
      this.$root.logOut();
    }
  },
  methods: {
    newTransaction() {
      this.idWithdraw = "";
      this.message = "";
      this.successful = false;
      this.loading = false;
    },
    comprovante() {
      this.$router.push("/proof/" + this.idWithdraw);
    },
    handleSendMoney(data) {
      this.idWithdraw = "";
      this.message = "";
      this.successful = false;
      this.loading = true;

      this.$store.dispatch("transaction/sendMoney", data).then(
        (data) => {
          this.message = data.message;
          this.idWithdraw = data.idWithdraw;
          this.successful = true;
          this.loading = false;
          this.fields.cpf = "";
          this.fields.typePix = "";
          this.fields.chavePix = "";
          this.fields.value = "";
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.idWithdraw = "";
          this.successful = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>
  
  <style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
  